module.exports = __webpack_public_path__ + "img/mouseClick.4fbf2729.svg";